import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { getStatusByStep, changeStepAndStatus } from './api';
import { servicesManager } from '../../App.js';
function StatusCell({ item, ...props }) {
  const [status, setStatus] = useState([]);
  const [statu, setStatu] = useState({
    label: item.statusName,
    value: item.status,
  });

  const customStyles = {
    indicatorSeparator: () => {
      null;
    }, // removes the "stick"
    placeholder: (provided, state) => ({
      ...provided,
      color: '#fff',
      padding: '0',
    }),
    menu: base => ({
      ...base,
      backgroundColor: '#556472',
      padding: '0',
    }),
    menuList: base => ({
      ...base,
      paddingTop: '0px',
    }),
    option: (provided, state) => ({
      ...provided,
      color: '#FFFFFF',
      backgroundColor: state.isFocused ? '#91B9CD' : '#556472',
      padding: '12px 20px',
    }),
    control: () => ({
      color: '#fff',
      // width: '120px',
      height: 24,
      alignItems: 'center',
      display: 'flex',
      backgroundColor: 'transparent',
      margin: 0,
      padding: '0',
      borderRadius: 2,
      flexWrap: 'inherit',
    }),
    singleValue: base => ({
      ...base,
      color: '#fff',
    }),
    multiValue: (styles, { data }) => {
      return {
        ...styles,
        color: '#fff',
        backgroundColor: '#556472',
        padding: '0',
      };
    },
    multiValueLabel: (styles, { data }) => ({
      ...styles,
      color: '#fff',
    }),
  };
  const statusHandleChange = async e => {
    let payload = {
      id: item.id,
      status: e.value,
    };
    const { UINotificationService } = servicesManager.services;
    const result = await changeStepAndStatus(payload);
    if (result.status == 'success') {
      setStatu(e);
      props.onChange && props.onChange(true);
    } else {
      const message = result.tip;
      UINotificationService.show({
        title: '提示',
        message,
        type: 'error',
        autoClose: true,
      });
    }
  };
  useEffect(() => {
    const getSteps = async () => {
      try {
        const result = await getStatusByStep({ step: item.step });
        let list = result.data.map(i => {
          return { value: i.id, label: i.name };
        });
        setStatus(list);
      } catch (error) {
        console.warn(error);
      }
    };
    getSteps();
  }, [item.step]);
  return (
    <>
      <Select
        styles={customStyles}
        placeholder="请选择"
        value={statu}
        options={status}
        className="status"
        id="status"
        menuPosition={'fixed'}
        onChange={statusHandleChange}
      />
    </>
  );
}

StatusCell.propTypes = {
  onChange: PropTypes.func,
  item: PropTypes.object,
};
export default StatusCell;
